/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';

/**
 * 
 * @export
 * @interface CreateDocumentForLead201Response
 */
export interface CreateDocumentForLead201Response {
    /**
     * 
     * @type {Document}
     * @memberof CreateDocumentForLead201Response
     */
    data?: Document;
}

/**
 * Check if a given object implements the CreateDocumentForLead201Response interface.
 */
export function instanceOfCreateDocumentForLead201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateDocumentForLead201ResponseFromJSON(json: any): CreateDocumentForLead201Response {
    return CreateDocumentForLead201ResponseFromJSONTyped(json, false);
}

export function CreateDocumentForLead201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentForLead201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DocumentFromJSON(json['data']),
    };
}

export function CreateDocumentForLead201ResponseToJSON(value?: CreateDocumentForLead201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DocumentToJSON(value.data),
    };
}

